import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";
import { motion } from "framer-motion";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  // WhatsApp click handler
  const openWhatsApp = () => {
    window.open("https://wa.me/919511291664?text=Hello%20Doctor!", "_blank");
  };

  return (
    <motion.footer
    className="footer"
      style={{
        backgroundColor: "#7b4a1c",
        color: "#fff",
        padding: "60px 0",
        position: "relative",
      }}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
    >
      <Container>
        <Row>
          {/* Left Section */}
          <Col md={4} className="mb-4">
            <h5 style={{ fontWeight: "bold" }}>Dr Trupti Hambire</h5>
            <p>Skin, Laser & Hair Clinic</p>
            <p>
              Dr Trupti Hambire is one of the Best Cosmetologiest in Pimpri-Chinchwad
              providing reliable and effective skin, laser, and hair treatments.
            </p>
            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
              <li>• 5+ Years of Experience</li>
              <li>• BAMS, PGDCC (Cosmetologiest & Aayurweda)</li>
            </ul>
            <p style={{ marginTop: "10px" }}>
              <a href="#about" className="footer-link">
                Learn More About Doctor
              </a>
              <br />
              <a href="#clinic" className="footer-link">
                Learn More About Clinic
              </a>
            </p>
          </Col>

         {/* Concerns */}
          <Col md={2} className="mb-4">
            <h6 style={{ fontWeight: "bold", marginBottom: "20px" }}>
              Concerns
            </h6>

            <ul className="footer-list">

              <li>
                <Link to="/concerns/ageing" className="footer-item">
                  Ageing
                </Link>
              </li>

              <li>
                <Link to="/concerns/wrinkles" className="footer-item">
                  Wrinkles
                </Link>
              </li>

              <li>
                <Link to="/concerns/dark-circles" className="footer-item">
                  Dark Circles
                </Link>
              </li>

              <li>
                <Link to="/concerns/laugh-lines" className="footer-item">
                  Laugh Lines
                </Link>
              </li>

              <li>
                <Link to="/concerns/thin-lips" className="footer-item">
                  Thin Lips
                </Link>
              </li>

              <li>
                <Link to="/concerns/neck-lines" className="footer-item">
                  Neck Lines
                </Link>
              </li>

              <li>
                <Link to="/concerns/sagging-skin" className="footer-item">
                  Sagging
                </Link>
              </li>

              <li>
                <Link to="/concerns/uneven-skin-tone" className="footer-item">
                  Uneven Skin Tone
                </Link>
              </li>

              <li>
                <Link to="/concerns" className="footer-item">
                  View More
                </Link>
              </li>
            </ul>
          </Col>

          {/* Treatments */}
          <Col md={3} className="mb-4">
            <h6 style={{ fontWeight: "bold", marginBottom: "20px" }}>
              Treatments
            </h6>

            <ul className="footer-list">

              <li>
                <Link to="/treatments/acne" className="footer-item">
                  Acne & Scar Treatment
                </Link>
              </li>

              <li>
                <Link to="/treatments/tattoo-removal" className="footer-item">
                  Tattoo Removal
                </Link>
              </li>

              <li>
                <Link to="/treatments/hair-removal" className="footer-item">
                  Hair Removal
                </Link>
              </li>

              <li>
                <Link to="/treatments/laser-hair-removal" className="footer-item">
                  Laser Hair Removal
                </Link>
              </li>

              <li>
                <Link to="/treatments/carbon-laser-facial" className="footer-item">
                  Carbon Laser Facial
                </Link>
              </li>

              <li>
                <Link to="/treatments/microneedling" className="footer-item">
                  Microneedling
                </Link>
              </li>

              <li>
                <Link to="/treatments/chemical-peel" className="footer-item">
                  Chemical Peel
                </Link>
              </li>

              <li>
                <Link to="/treatments/prp-treatment" className="footer-item">
                  PRP
                </Link>
              </li>

              <li>
                <Link to="/treatments" className="footer-item">
                  View More
                </Link>
              </li>

            </ul>
          </Col>

          {/* Contact Section */}
          <Col md={3} className="mb-4">
            <h6 style={{ fontWeight: "bold" }}>Have Queries?</h6>
            <Form>
              <Form.Group controlId="formBasicEmail" className="d-flex">
                <Form.Control type="text" placeholder="Your Mobile Number" />
                <Button variant="light" style={{ marginLeft: "5px" }}>
                  ➤
                </Button>
              </Form.Group>
            </Form>
            <p style={{ marginTop: "10px" }}>We will get back to you soon.</p>
            <p>
              <FaPhoneAlt /> +91 9511291664
            </p>
            <p>
              <FaEnvelope /> truptihambire111@gmail.com
            </p>
            <p>
              <FaMapMarkerAlt /> shop no.-5, Ground floor, Destination Ostia, Alandi - Moshi Rd, near axis bank, near Y junction, Moshi Gaon, Dudulgaon, Pimpri-Chinchwad, Maharashtra 412105
            </p>
            <div>
              <a href="/" className="footer-icon">
                <FaFacebookF />
              </a>
              <a href="/" className="footer-icon">
                <FaInstagram />
              </a>
              <a href="/" className="footer-icon">
                <FaYoutube />
              </a>
            </div>
          </Col>
        </Row>

        {/* Bottom Bar */}
        <Row className="pt-3 mt-3 border-top">
          <Col className="text-center">
            <p style={{ margin: 0 }}>
              © 2025, All Rights Reserved By{" "}
              <span style={{ fontWeight: "bold", color: "#ffcc66" }}>
                Dr Trupti Hambire
              </span>
            </p>
          </Col>
        </Row>
      </Container>

      {/* WhatsApp Floating Button */}
      <Button
        onClick={openWhatsApp}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          borderRadius: "50%",
          backgroundColor: "#25D366",
          border: "none",
          width: "60px",
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "28px",
          boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
          zIndex: 1000,
        }}
      >
        <FaWhatsapp />
      </Button>
    </motion.footer>
  );
};

export default Footer;
